import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http.service';
import moment from 'moment';
import { ChatConfig } from './chat-url.config';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  constructor(private http: HttpService) { }

  getUserMessage(messagePayload) {
    return this.http.post(ChatConfig.EndPoint.chat.getUserMessage, messagePayload);
  }

  getUserConversation(messagePayload) {
    return this.http.post(ChatConfig.EndPoint.chat.getUserConversation, messagePayload);
  }
  getChatUsers(userId: number, case_id: number) {
    return this.http.get(ChatConfig.EndPoint.chat.getChatUsers.replace('{id}', String(userId)) + `${case_id ? '?caseid=' + case_id : ''}`);
  }

  getCaseList() {
    return this.http.get(ChatConfig.EndPoint.chat.getCaseList);
  }

  getUnreadMessages() {
    return this.http.get(ChatConfig.EndPoint.chat.getUnreadMessages);
  }

  getUserSession(id: any) {
    return this.http.get(ChatConfig.EndPoint.chat.getUserSession.replace('{id}', String(id)));
  }

  getOnlineUsers() {
    return this.http.get(ChatConfig.EndPoint.chat.getOnlineUsers);
  }

  getChatUsersByCase(id: number) {
    return this.http.get(ChatConfig.EndPoint.chat.getChatUsersByCase + `${id ? '?caseid=' + id : ''}`);
  }

  getAllChatUsers(case_id: number) {
    return this.http.get(ChatConfig.EndPoint.chat.getAllChatUsers + `${case_id ? '?caseid=' + case_id : ''}`);
  }

  addChatUsers(payload: any) {
    return this.http.post(ChatConfig.EndPoint.chat.addChatUsers, payload);
  }

  getChildByCase(case_id: number) {
    return this.http.get(ChatConfig.EndPoint.chat.getChildByCase.replace('{case_id}', String(case_id)));
  }

  getSignedDocumentUrl(document) {
    return this.http.post(ChatConfig.EndPoint.document.getSignedDocumentUrl, document);
  }

  getDocumentCategories() {
    return this.http.get(ChatConfig.EndPoint.document.getDocumentCategories);
  }

  getDocumentTypes(parentKey: string) {
    return this.http.get(ChatConfig.EndPoint.document.getDocumentTypes.replace('{key}', parentKey));
  }

  addAttachment(payload: any) {
    return this.http.post(ChatConfig.EndPoint.document.addAttachment, payload)
  }

  updateDocumentStatus(payload: any) {
    return this.http.patch(ChatConfig.EndPoint.document.updateDocumentStatus.replace('{document_id}', payload.id), payload);
  }

  getAttachmentById(document_id: string) {
    return this.http.get(ChatConfig.EndPoint.document.getAttachmentById.replace('{document_id}', document_id));
  }

  formatBytes(byte) {
    const units = ['bytes', 'KB', 'MB', 'GB'];
    let index = 0;
    let bytes = parseInt(byte, 10) || 0;

    while (bytes >= 1024 && ++index) {
      bytes = bytes / 1024;
    }

    return bytes.toFixed(bytes < 10 && index > 0 ? 1 : 0) + ' ' + units[index];
  }

  getAbbrevation(name: string) {
    return (name)
      .split(' ')
      .map(_name => _name.charAt(0).toLocaleUpperCase())
      .join('')
  }

  getFileExtension(fileType) {
    const fileExtension = [
      {
        type: 'text/plain',
        extension: 'TXT',
        icon: 'fa fa-file-text-o'
      },
      {
        type: 'application/pdf',
        extension: 'PDF',
        icon: 'fa fa-file-pdf-o'
      },
      {
        type: 'text/csv',
        extension: 'CSV',
        icon: 'fa fa-file-excel-o'
      },
      {
        type: 'application/json',
        extension: 'JSON',
        icon: 'fa fa-file-text-o'
      },
      {
        type: 'image/png',
        extension: 'PNG',
        icon: 'fa fa-file-picture-o'
      },
      {
        type: 'image/jpeg',
        extension: 'JPG',
        icon: 'fa fa-file-picture-o'
      },
      {
        type: 'image/jpg',
        extension: 'JPG',
        icon: 'fa fa-file-picture-o'
      }
    ];

    return fileExtension.filter(file => file.type === fileType)[0];
  }

  getMessageDate(messageIndex: number, messages: Array<any>): string {
    const dateToday = moment().format('DD MMMM YYYY');
    const dateYesterday = moment().subtract(1, 'day').format('DD MMMM YYYY');
    const messageDate = moment(messages[messageIndex].createdat).format('DD MMMM YYYY');
    if (messageDate === dateToday) {
      return 'Today';
    } else if (messageDate === dateYesterday) {
      return 'Yesterday';
    } else {
      return messageDate;
    }
  }
}
